<template>
  <div class="hearTopBox">
    <div class="fixBox">
      <div class="heardContent">
        <div class="heardLeft">
          <img src="https://htmlqiniu.jihex.com/newLOGO.png" alt="">
          <div class="heardTitle">太目</div>
          <ul class="ulBox">
            <li>
              <a :class="activeIndex==0?'activeStyle':''" @click="selectTab(0)" href="javascript:;">首页</a>
            </li>
            <li><a :class="activeIndex==1?'activeStyle':''" @click="selectTab(1)" href="javascript:;">产品与服务</a></li>
            <li><a :class="activeIndex==2?'activeStyle':''" @click="selectTab(2)" href="javascript:;">价格</a></li>
            <li><a :class="activeIndex==3?'activeStyle':''" @click="selectTab(3)" href="javascript:;">关于太目</a></li>
            <li :class="`lineBox${activeIndex}`" class="lineBox"></li>
          </ul>
        </div>
        <div class="heardRight">
          <div @click="clickLogin" class="registerBox">登录</div>
          <div @click="clickRegister" class="loginBox">免费试用</div>
        </div>
      </div>
    </div>
    <loginDia v-if="loginDiaShow" v-model="loginDiaShow" @changeEvent="clickRegister"></loginDia>
    <registerDia v-if="registerShow" v-model="registerShow" />
  </div>
</template>

<script>
import loginDia from '@/components/loginDia'
import registerDia from '@/components/registerDia';
import webHost from '@/api/config.js'
export default {
  components:{
    loginDia,
    registerDia
  },
  data () {
    return {
      activeIndex:0,
      registerShow:false,
      loginDiaShow:false,
    }
  },
  methods:{
    selectTab(num) {
      this.activeIndex = num;
      if(num==0) {
        this.$router.push({ name: "HomePage" });
      }else if(num==1) {
        this.$router.push({ name: "IntroductionPage" });
      }else if(num==2) {
        this.$router.push({ name: "Membership" });
      }else if(num==3) {
        this.$router.push({ name: "AboutUs" });
      }
    },
    clickRegister() {
      window.open(`${webHost}/#/login?isRegisterShow=true`)
      // this.$nextTick(() => {
      //   this.registerShow = true
      //   this.loginDiaShow = false
			// })
    },
    clickLogin() {
      console.log(999)
      window.open(`${webHost}/#/login`)
      // this.$nextTick(() => {
			// 	this.loginDiaShow = true
			// })
      // console.log('loginDiaShow')
    }
  },
  mounted() {
    console.log(this.$router.history.current.name)
    if(this.$router.history.current.name=='HomePage') {
      this.activeIndex = '0'
    }else if(this.$router.history.current.name=='IntroductionPage') {
      this.activeIndex = '1'
    }else if(this.$router.history.current.name=='Membership') {
      this.activeIndex = '2'
    }else if(this.$router.history.current.name=='AboutUs') {
      this.activeIndex = '3'
    }
  }
}
</script>

<style lang="scss" scoped>
 .fixBox {
   position: fixed;
   left: 0;
   right: 0;
   width: 100%;
   background: #ffffff;
   z-index: 99;
 }
 .hearTopBox {
   width: 100%;
   height: 64px;
   background: #ffffff;
   .heardContent {
     width: 1200px;
     margin: 0 auto;
     padding: 0 10px;
     box-sizing: border-box;
     display: flex;
     align-items: center;
     justify-content: space-between;
     .heardLeft {
       display: flex;
       align-items: center;
       img {
         width: 50px;
         height: 50px;
         display: block;
       }
       .heardTitle {
         margin-left: 10px;
         font-size:18px;
         font-weight:600;
         color:rgba(67,69,71,1);
         line-height:28px;
         margin-right: 60px;
       }
     }
     ul,li {
       margin: 0;
       padding: 0;
       list-style: none;
     }
     .heardLeft,.heardRight {
       height: 64px;
       line-height: 64px;
       display: flex;
       align-items: center;
       ul {
         display: flex;
         align-items: center;
         position: relative;
       }
       .lineBox {
         position: absolute;
         left: 20px;
         top: 60px;
         width: 28px;
         height: 4px;
         background: #FD7D6F;
         padding: 0px;
         transition: all 200ms linear;
       }
       .lineBox1 {
         left: 108px;
       }
       .lineBox2 {
         left: 196px;
       }
       .lineBox3 {
         left: 276px;
       }
       li {
         height: 64px;
         padding: 0 20px;
          a {
            text-decoration: none;
            color: #434547;
            display: block;
            height: 64px;
            font-weight:600;
            font-size:14px;
            box-sizing: border-box;
            &:hover {
              color: #FD7D6F;
            }
          }
          .activeStyle {
            // border-bottom: 4px solid #FD7D6F;
            color: #FD7D6F;
          }

       }
     }
   }
 }
 .registerBox {
   height: 32px;
   line-height: 32px;
   padding: 0 26px;
   background:rgba(255,250,250,1);
   border-radius:16px;
   border:1px solid rgba(253,125,111,1);
   font-size:14px;
   color:rgba(253,125,111,1);
   margin-left: 20px;
   box-sizing: border-box;
   &:hover {
     background: #ed6758;
     color: #fff;
     cursor: pointer;
   }
 }
 .loginBox {
  height:32px;
  background:linear-gradient(90deg,rgba(255,141,126,1) 0%,rgba(246,115,101,1) 100%);
  border-radius:16px;
  padding: 0 26px;
  line-height: 32px;
  font-size:14px;
  margin-left:10px;
  color:rgba(255,255,255,1);
  &:hover {
    background: #ed6758;
    cursor: pointer;
  }
 }
</style>



// WEBPACK FOOTER //
// src/components/navTop/hearTop.vue